<template>
  <img
    class="object-cover"
    src="@/assets/images/navbar-icons/nav-friends-icon.webp"
  >
</template>